export const isSpaceAvailable = (
  spaceCount: number | undefined,
  firstEntryAvailableDate: string | undefined,
) => spaceCount === 0 && !firstEntryAvailableDate;
